
import CompareProductCard from './CompareProductCard'

import { isEven } from 'vessel/utils'

export default {
  name: 'CompareTableLayout',
  components: {
    CompareProductCard
  },
  props: {
    primary: {
      type: Object,
      default: null
    },
    products: {
      type: Array,
      default: null
    },
    attributes: {
      type: Array,
      default: null
    },
    count: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: 1
    }
  },
  vessel: {
    label: {
      padding: 'sm',
      fontWeight: 'semibold',
      fontSize: 'sm',
    },
    attribute: {
      textAlign: 'left',
      padding: 'sm',
      fontSize: 'sm'
    }
  },
  computed: {
    columns() {
      return this.perPage + 2
    },
    colSpan() {
      const max = this.count + 2
      return max < this.columns ? max : this.columns
    }
  },
  methods: {
    rowBg(index) {
      return isEven(index) ? 'grey-lightest' : null
    }
  }
}
